import {
  followersSearch,
  personalizeOpens,
  previewOpensMessage,
  regenerateSelfServiceOpensMessage,
  responseReport,
  selfServiceOpensSettings,
  selfServiceStatus,
} from '@/constants/endpoints';

import { APIClient } from '@/lib/ApiClient';

const apiClient = new APIClient();

export function fetchSearchFollowersForOpens(pageNumber, params = {}) {
  // Expect caller to build filters payload. We just pass through to API.
  return apiClient.create(
    followersSearch(pageNumber),
    { for_opens: true, ...params },
    true
  );
}

export function fetchHistoryFollowersForOpens(
  pageNumber,
  date,
  actionType = 'approved',
  params = {}
) {
  // Format date to YYYY-MM-DD - handle both Date objects and strings
  const formattedDate =
    typeof date === 'string' ? date : date.toISOString().split('T')[0];

  const historyParams = {
    action: 'history',
    date: formattedDate,
    action_type: actionType,
    ...params,
  };

  return apiClient.create(
    followersSearch(pageNumber),
    { ...historyParams },
    true
  );
}

export function processFollowerAction(action, data) {
  return apiClient.create(
    personalizeOpens,
    {
      action,
      data,
    },
    true
  );
}

export function fetchSearchFollowersForSelfServiceOpens(
  pageNumber,
  params = {}
) {
  // Self-service opens uses action instead of for_opens
  return apiClient.create(
    followersSearch(pageNumber),
    { action: 'self_service_opens', ...params },
    true
  );
}

export function fetchHistoryFollowersForSelfServiceOpens(
  pageNumber,
  date,
  actionType = 'sent',
  params = {}
) {
  // Format date to YYYY-MM-DD - handle both Date objects and strings
  const formattedDate =
    typeof date === 'string' ? date : date.toISOString().split('T')[0];

  const historyParams = {
    action: 'self_service_opens_history',
    date: formattedDate,
    action_type: actionType,
    ...params,
  };

  return apiClient.create(
    followersSearch(pageNumber),
    { ...historyParams },
    true
  );
}

export function processSelfServiceFollowerAction(followerIds, status) {
  return apiClient.create(
    selfServiceStatus,
    {
      follower_ids: followerIds,
      status: status,
    },
    true
  );
}

export function getSelfServiceOpensSettings() {
  return apiClient.get(selfServiceOpensSettings, null, true);
}

export function saveSelfServiceOpensSettings(personalizedSystemPrompt) {
  return apiClient.create(
    selfServiceOpensSettings,
    {
      personalized_system_prompt: personalizedSystemPrompt,
    },
    true
  );
}

export function previewOpensMessagePreview(customPrompt) {
  return apiClient.create(
    previewOpensMessage,
    {
      custom_prompt: customPrompt,
    },
    true
  );
}

export function fetchResponseReport(startDate, endDate) {
  return apiClient.get(
    responseReport,
    {
      start_date: startDate,
      end_date: endDate,
    },
    true
  );
}

export function regenerateOpensMessage(followerId) {
  return apiClient.create(
    regenerateSelfServiceOpensMessage,
    {
      follower_ids: [followerId],
    },
    true
  );
}
